import { createContext, useContext, ReactNode, useEffect, useState } from "react";
import { usePartnerBranding, PartnerBranding, SubPartnerInfo } from "@/hooks/usePartnerBranding";

interface PartnerThemeContextType {
  branding: PartnerBranding | null;
  subPartner: SubPartnerInfo | null;
  isPartner: boolean;
  isLoading: boolean;
  hasPartnerBranding: boolean;
}

const PartnerThemeContext = createContext<PartnerThemeContextType | undefined>(undefined);

export function PartnerThemeProvider({ children }: { children: ReactNode }) {
  const { branding, subPartner, isPartner, isLoading, hasPartnerBranding } = usePartnerBranding();

  return (
    <PartnerThemeContext.Provider
      value={{
        branding,
        subPartner,
        isPartner,
        isLoading,
        hasPartnerBranding,
      }}
    >
      {children}
    </PartnerThemeContext.Provider>
  );
}

export function usePartnerTheme() {
  const context = useContext(PartnerThemeContext);
  if (context === undefined) {
    throw new Error("usePartnerTheme must be used within a PartnerThemeProvider");
  }
  return context;
}
